<template>
  <div class="main-content">
    <div class="title-section">请选择认证机构</div>
    <!-- 核查认证流程 -->
    <div class="content">
      <div class="left-section">
          <img
            src="@/assets/images/chatpreview/verify_certify_left.png"
            alt="第三方核查"
            class="verify_certify_left"
          />
          <div class="section-title">第三方核查</div>
      </div>
      <div class="center-section">
          <div class="verify_certify_btn">
            <div class="one_row">
              <el-tooltip 
                content="TÜV南德" 
                placement="bottom" 
                effect="light"
                :open-delay="300"
                popper-class="chat-preview-tooltip"
              >
                <div class="btn_item" @click="openEmailClient('TÜV 南德')">
                  <img
                    src="@/assets/images/chatpreview/verify_certify_1.png"
                    alt="TÜV 南德"
                    class="verify_certify_btn_1"
                  />
                </div>
              </el-tooltip>
              <el-tooltip 
                content="TÜV莱茵" 
                placement="bottom" 
                effect="light"
                :open-delay="300"
                popper-class="chat-preview-tooltip"
              >
                <div class="btn_item" @click="openEmailClient('TÜV 莱茵')">
                  <img
                    src="@/assets/images/chatpreview/verify_certify_2.png"
                    alt="TÜV 莱茵"
                    class="verify_certify_btn_2"
                  />
                </div>
              </el-tooltip>
              <el-tooltip 
                content="中国质量认证中心" 
                placement="bottom" 
                effect="light"
                :open-delay="300"
                popper-class="chat-preview-tooltip"
              >
                <div class="btn_item" @click="openEmailClient('中国质量认证中心')">
                  <img
                    src="@/assets/images/chatpreview/verify_certify_3.png"
                    alt="中国质量认证中心"
                    class="verify_certify_btn_3"
                  />
                </div>
              </el-tooltip>
            </div>
            <div class="two_row">
              <el-tooltip 
                content="SGS认证" 
                placement="bottom" 
                effect="light" 
                :open-delay="300"
                popper-class="chat-preview-tooltip"
              >
                <div class="btn_item" @click="openEmailClient('SGS 认证')">
                  <img
                    src="@/assets/images/chatpreview/verify_certify_4.png"
                    alt="SGS 认证"
                    class="verify_certify_btn_4"
                  />
                </div>
              </el-tooltip>
              <el-tooltip 
                content="华测认证" 
                placement="bottom" 
                effect="light"
                :open-delay="300"
                popper-class="chat-preview-tooltip"
              >
                <div class="btn_item" @click="openEmailClient('华测认证')">
                  <img
                    src="@/assets/images/chatpreview/verify_certify_5.png"
                    alt="华测认证"
                    class="verify_certify_btn_5"
                  />
                </div>
              </el-tooltip>
            </div>
          </div>
      </div>
      <div class="right-section">
          <img
            src="@/assets/images/chatpreview/verify_certify_right.png"
            alt="颁发认证"
            class="verify_certify_right"
          />
         <div class="section-title">颁发认证</div>
      </div>
    </div>

    <div class="arrow_section">
      <img 
        src="@/assets/images/chatpreview/verify_certify_arrow.png"
        alt="箭头"
        class="verify_certify_arrow"
       />
    </div>
    <!-- 底部信息区域 -->
    <div class="footer-section">
      <div class="company-logo-section">
        <img
          src="@/assets/images/chatpreview/verify_certify_company.png"
          alt="公司logo"
          class="company-logo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "VerifyCertify",
  props: {
    // 来自 ProjectInfo 的企业名称，由父组件 ChatPreview 从 previewData.project_info 传入
    companyName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      serviceName: '', // 服务名称
    };
  },
  computed: {
    ...mapState(["accessType", "userInfo"]),
  },
  methods: {
    // 打开电脑默认邮箱
    openEmailClient(certifyName) {
      if (this.accessType === "tpc") {
        this.serviceName = '碳盘查';
      } else if (this.accessType === "tzj") {
        this.serviceName = '碳足迹';
      }

      const recipient = 'customerservice@carbonneutrality-group.com';
      const subject = `${this.serviceName}认证服务申请 - ${this.companyName || "-"}`;
      const body = `中碳普惠云团队，\n
      ${this.companyName || "-"} 已在系统中完成“${this.serviceName}”计算和报告，现申请启动第三方认证流程。\n\n业务相关信息：\n· 认证机构：${certifyName}\n· 系统账户：${this.userInfo?.user_name}，${this.userInfo?.company}\n· 联系电话：${this.userInfo?.phone}\n\n请查收并推进后续事宜。`; 

      // 多收件人 + 抄送 `mailto:admin@example.com,support@example.com?cc=manager@example.com&subject= ${encodeURIComponent('紧急通知')}&body= ${encodeURIComponent('详情如下：\n...')}`
      const mailtoUrl = `mailto: ${recipient}?subject= ${encodeURIComponent(subject)}&body= ${encodeURIComponent(body)}`;

      // 在新窗口/标签页打开（某些浏览器要求）
      window.open(mailtoUrl, '_blank');
      // 或者直接跳转（会离开当前页面）：
      // window.location.href = mailtoUrl;
    }
  }
};
</script>

<style scoped lang="scss">
.main-content {
  width: 100%;
  height: 269px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.title-section {
  font-size: 10px;
  font-weight: 400;
  color: rgba(170, 179, 187, 1);
  text-align: center;
  margin-bottom: 8px;
}

.content {
  padding: 0 70px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.verify_certify_left {
  width: 87px;
  height: 104px;
}

.left-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}

.center-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.right-section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}

.verify_certify_btn {
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .one_row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .two_row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 20px;
  }

  .btn_item {
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      cursor: pointer;
      transform: scale(1.1);
      transition: transform 0.3s ease;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.arrow_section {
  display: flex;
  justify-content: center;
  align-items: center;

  .verify_certify_arrow {
    width: 130px;
    height: 30px;
  }
}

.verify_certify_right {
  width: 87px;
  height: 104px;
}

.section-title {
  font-size: 14px;
  font-weight: 400;
  color: rgba(5, 32, 49, 1);
}

/* 底部信息区域 */
.footer-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.company-logo-section {
  width: 200px;
}
</style>
